import {UpdateUserProfileApiPayload} from "../../../../react-query-hooks/profile/types";
import {ProfileFormValues} from "../form/schema-validation";

export function updateUserProfileDto(
  values: ProfileFormValues
): UpdateUserProfileApiPayload {
  return {
    behance: values.socialLinks.find((x) => x.name === "Behance")?.link ?? null,
    country: values.country,
    discord: values.socialLinks.find((x) => x.name === "Discord")?.link ?? null,
    display_name: values.displayName,
    dribble: values.socialLinks.find((x) => x.name === "Dribbble")?.link ?? null,
    facebook: values.socialLinks.find((x) => x.name === "Facebook")?.link ?? null,
    firstName: values.firstName,
    github: values.socialLinks.find((x) => x.name === "Github")?.link ?? null,
    how_did_you_find_us: values.how_did_you_find_us,
    instagram: values.socialLinks.find((x) => x.name === "Instagram")?.link ?? null,
    lastName: values.lastName,
    linkedin: values.socialLinks.find((x) => x.name === "LinkedIn")?.link ?? null,
    shortBio: values.shortBio,
    shortDescription: values.shortDescription,
    tiktok: values.socialLinks.find((x) => x.name === "TikTok")?.link ?? null,
    twitch: values.socialLinks.find((x) => x.name === "Twitch")?.link ?? null,
    twitter: values.socialLinks.find((x) => x.name === "Twitter/X")?.link ?? null,
    username: values.username,
    website: values.socialLinks.find((x) => x.name === "Website")?.link ?? null,
    youtube: values.socialLinks.find((x) => x.name === "YouTube")?.link ?? null,
  };
}
